module.exports = __webpack_public_path__ + "static/media/provider-02.ef75eb5d.png";